<template>
  <div>
    <div class="title-wrap">
      <span class="title">退款商品</span>
    </div>
    <div>
      <div style="display: flex">
        <el-card class="card-item" style="flex: 1">
          <z-table
            v-loading="loading"
            ref="productListable"
            :data="proList"
            :pagination="false"
            :columns="columns"
            :selection="resData.refundType !== 1"
            @selection-change="handleSelectionChange"
            @select="handleSelect"
          >
            <template v-slot:id="{ row }">
              <div class="products">
                <img :src="row.imageUrl">
                <div>
                  <el-tooltip offset="-200" :content="row.title" placement="top-end">
                    <p>{{row.title}}</p>
                  </el-tooltip>
                  <p>{{row.variantOptionValue}} <span v-if="row.discountType === 2" class="order-item-tying">搭售</span></p>
                  <p>{{symbol}}{{row.discountSaleAmount.toFixed(2)}}</p>
                </div>
              </div>
            </template>
            <template v-slot:refundableQuantity="{ row, $index }">
              <!--            :disabled="!selectList.includes(String(row.id))"-->
              <el-input
                :disabled="resData.refundType === 1"
                :max="row.refundableQuantity"
                :min="0"
                v-model="row.inputAmount"
                type="number"
                @blur="(e) => { listenInput($index) }"
                style="width: 130px">
                <template slot="append">/{{row.refundableQuantity}}</template>
              </el-input>
            </template>
            <template v-slot:refundableAmount="{ row }">
              <span style="display: inline-block;height: 50px;line-height: 50px">{{ symbol }}{{floatBeat((row.discountSaleAmount * (row.inputAmount/(row.refundQuantity + row.refundableQuantity)))) || 0
                }}</span>
              <el-collapse>
                <el-collapse-item title="详情">
                  <div><span class="coltitle">商品总价</span>{{symbol}}{{floatBeat((row.saleAmount * (row.inputAmount/(row.refundQuantity + row.refundableQuantity)))) || 0}}</div>
                  <div><span class="coltitle">折扣</span>{{symbol}}{{floatBeat((row.discountAmount * (row.inputAmount/(row.refundQuantity + row.refundableQuantity)))) || 0}}</div>
                  <div><span class="coltitle">商品实付价</span>{{symbol}}{{floatBeat((row.discountSaleAmount * (row.inputAmount/(row.refundQuantity + row.refundableQuantity)))) || 0}}</div>
                </el-collapse-item>
              </el-collapse>
            </template>
          </z-table>
        </el-card>
        <el-card class="card-item content-right" style="flex-basis: 280px;margin-left: 20px">
          <p>订单金额</p>
          <div>
            <span>商品总价</span>
            <span>{{symbol}}{{Number(resData.orderAmount.productTotalAmount).toFixed(2) || 0}}</span>
          </div>
          <div>
            <span>折扣</span>
            <span>{{symbol}}{{Number(resData.orderAmount.discountAmount).toFixed(2) || 0}}</span>
          </div>
          <div>
            <span>实付金额</span>
            <span>{{symbol}}{{Number(resData.orderAmount.payItemAmount).toFixed(2) || 0}}</span>
          </div>
          <div>
            <span>运费</span>
            <span>{{symbol}}{{Number(resData.orderAmount.payShipAmount).toFixed(2) || 0}}</span>
          </div>
          <div>
            <span>实际总付款金额</span>
            <span>{{symbol}}{{Number(resData.orderAmount.payTotalAmount).toFixed(2) || 0}}</span>
          </div>
        </el-card>
      </div>
      <el-card class="card-item" v-loading="loading1">
        <div class="ensure">
          <p>退款金额<span>共{{amount}}件商品</span></p>
          <label>
            <el-tooltip offset="-200" placement="top-end">
              <div slot="content">手动输入退款金额，保存后再次退款将无法选择<br>退款商品，只能自行输入金额进行退款</div>
              <el-input
                v-model="refund"
                @blur="checkRefund"
                type="number"
                style="width: 268px;margin-right: 24px"></el-input>
            </el-tooltip>
            <el-button :disabled="refund <= 0" type="primary" @click="postRefund">确认退款</el-button>
          </label>
          <div class="info">
<!--            <div>-->
<!--              <span>税后商品可退款金额</span>-->
<!--              <span>{{symbol}}{{resData.refundOrderAmountInfo.orderRefundableAmount}}</span>-->
<!--            </div>-->
<!--            <div>-->
<!--              <span>运费金额</span>-->
<!--              <span>{{symbol}}{{resData.refundOrderAmountInfo.shippingRefundableAmount}}</span>-->
<!--            </div>-->
            <div>
              <span>订单剩余可退款金额(包含运费)</span>
              <span>{{symbol}}{{Number(resData.refundOrderAmountInfo.orderRefundableAmount).toFixed(2)}}</span>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { getOrderRefundDetail, postRefund } from '@/server/order'
import {floatBeat} from '@/utils/index';

export default {
  name: 'orderRefund',
  data() {
    return {
      loading: false,
      loading1: false,
      columns: [
        {
          prop: 'id',
          label: '商品',
          minWidth: 170
        },
        {
          prop: 'refundableQuantity',
          label: '退款数量/总数',
          // minWidth: 180
        },
        {
          prop: 'refundableAmount',
          label: '退款金额',
          width: 190,
          hasChildren: true,
          renderHeader: (h, { column, $index }) => {
            return [
              '可退款金额',
              h(
                'el-tooltip',
                {
                  props: {
                    content: '商品可退款金额=商品售价-折扣金额',
                    placement: 'top'
                  }
                },
                [
                  h('span', {
                    class: {
                      'el-icon-question': true
                    }
                  })
                ]
              )
            ]
          }
        },
      ],
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        pageSizes: [10, 20, 50, 100, 200, 400, 600],
        total: 0
      },
      resData: {
        orderAmount: {
          productTotalAmount: 0,
          payItemAmount: 0,
          payShipAmount: 0,
          payTotalAmount: 0,
          discountAmount: 0
        },
        refundItemsInfo: [
          {
            discount_type: '',
            discount_title: '',
            items_by_code: [
              {
                discount_code: '',
                discount_items: []
              },
              {
                discount_code: '',
                discount_items: []
              }
            ]
          }
        ],
        refundOrderAmountInfo: {
          orderRefundableAmount: '',
        },
        refundType: null,
        symbol: ''
      },
      proList: [],
      selectListArr: [],
      selectList: '',
      refund: '',
      refundType: '',
    }
  },
  mounted() {
    this.getDetail(this.$route.params.id)
  },
  methods: {
    floatBeat(num) {
      return floatBeat(num, 2)
    },
    async postRefund() {
      this.loading1 = true
      let params = {
        order_no: this.$route.params.id,
        refund_amount: this.refund,
        refund_type: this.selectListArr.length === 0 ? 1 : 0,
        refund_items_info: this.selectListArr.map(v => {
          v.refund_quantity = v.inputAmount
          v.pay_amount = v.discountSaleAmount
          v.order_item_id = v.id
          return v
        }),
      }
      const {data} = await postRefund(params, this.$route.params.id)
      if (data.data.status === 1) {
        this.$message.success('退款成功！')
        this.getDetail(this.$route.params.id)
      } else {
        this.$message.error( '退款失败！')
        this.getDetail(this.$route.params.id)
      }
      this.loading1 = false
    },
    checkRefund(e) {
      let refund = this.floatBeat(Number(this.refund))
      if (this.refund !== this.total) {
        this.$refs.productListable.tableRef().clearSelection()
      }
      if (refund > this.resData.refundOrderAmountInfo.orderRefundableAmount) {
        this.refund = this.resData.refundOrderAmountInfo.orderRefundableAmount
      } else {
        this.refund = refund
      }
      console.log(this.refund, 'ddd')
    },
    listenInput(i) {
      this.proList[i].inputAmount = Math.floor(this.proList[i].inputAmount)
      if (this.proList[i].inputAmount > this.proList[i].refundableQuantity) {
        this.proList[i].inputAmount = this.proList[i].refundableQuantity
      }
      let row = this.proList[i]
      if (row.discountType === 2) {
        const tyingList = this.proList.filter(i => i.discountCode === row.discountCode && row.id !== i.id)
        tyingList.forEach(i => {
          this.$set(i, 'inputAmount', row.inputAmount)
        })
      }
      this.refund = this.total
    },
    async getDetail(id) {
      this.loading = true
      const {data} = await getOrderRefundDetail(id)
      let arr = []
      this.resData = data.data
      this.resData.refundItemsInfo.map(v => {
        arr = arr.concat(v.itemsByCode.map(val => {
          return val.discountItems
        }))
      })
      this.proList = arr.flat(2)
      this.proList.map((v, index) => {
        this.$set(this.proList[index], 'inputAmount', 0)
        this.$set(this.proList[index], 'selectId', v.id + index)
      })
      this.loading = false
    },
    handlePageChange() {

    },
    handleSelectionChange(list) {
      console.log('----selection change')
      this.selectListArr = list

      this.selectList = list.map(v => {
        return v.selectId
      }).join(',')
      this.refund = this.total
    },
    handleSelect(selection, row) {
      if (row.discountType === 2) {
        const tyingList = this.proList.filter(i => i.discountCode === row.discountCode && row.id !== i.id)
        this.$nextTick(() => {
          tyingList.forEach(i => {
            this.$refs.productListable.tableRef().toggleRowSelection(i, selection)
          })
        })
      }
    }
  },
  computed: {
    symbol() {
      return this.resData.symbol || '$'
    },
    amount() {
      if (this.proList.length === 0) return 0
      let arr = this.proList.map(v => {
        if (this.selectList.includes(v.selectId)) {
          return Number(v.inputAmount || 0)
        } else {
          return 0
        }
      })
      return arr.reduce((total, number) => { return total + number })
    },
    total() {
      let total = 0
      this.proList.map(v => {
        if (this.selectList.includes(String(v.selectId))) {
          if (v.refundableQuantity === Number(v.inputAmount)) {
            total = total + Number(v.refundableAmount)
          } else {
            total = total + this.floatBeat(Number((v.discountSaleAmount * (v.inputAmount / (v.refundQuantity + v.refundableQuantity)))))
          }
        }
      })
      return this.floatBeat(Number(total))
    }
  }
}
</script>
<style lang="scss" scoped>
.content-right{
  /deep/.el-card__body{
    >p{
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
    }
    >div{
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      margin: 12px 0;
    }
  }
}
.coltitle{
  display: inline-block;
  width: 80px;
}
.ensure{
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
  >p{
    font-size: 16px;
    color: #3A416F;
    font-weight: 500;
    margin: 12px 0 24px 0;
    >span{
      font-size: 14px;
      color: #5D6494;
      padding-left: 12px;
    }
  }
  .info{
    width: 268px;
    margin: 12px 0;
    >div{
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin: 8px 0;
    }
  }
}
.order-item-tying {
  display: inline-block;
  width: 36px;
  height: 21px;
  background: #ff8e40;
  color: #fff;
  line-height: 21px;
  text-align: center;
  border-radius: 2px;
}
.title-wrap {
  margin-top: 8px;
  margin-bottom: 24px;
}
.title {
  color: $--table-font-color;
  font-size: 20px;
}
.card-item {
  /deep/.el-table__body-wrapper {
    .el-table__row {
      &:hover {
        .el-collapse-item__header {
          background: #F0F2F5;
        }
        .el-collapse-item__wrap {
          background: #F0F2F5;
        }
      }
    }
  }
  /deep/.el-input-group__append{
    background: white;
    padding: 0 15px;
  }
  margin-bottom: 16px;
  /deep/.el-collapse-item__header{
    border-bottom: none;
    width: 52px;
    transition: background-color 0.2s;
  }
  /deep/.el-collapse-item__wrap{
    transition: background-color 0.2s;
  }
  /deep/.el-collapse{
    border: none;
    margin-top:-20px;
    //background: #F0F2F5;
  }
  .products{
    display: flex;
    margin: 8px 0;
    align-items: center;
    >img{
      width: 80px;
      height: 80px;
    }
    >div{
      margin-left: 12px;
      max-width: 75%;
      >p{
        &:first-child{
          font-size: 14px;
          color: #3A416F;
        }
        color: #5D6494;
        font-size: 12px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
        font-weight: 400;
        margin: 4px 0;
      }
    }
  }
}
</style>
